import { useState } from "react";
import { register } from "../api/auth";
import emtlogo from "../images/logo.svg";
import loginimg from "../images/login.png";

import Icon from "../components/em/Icon";
import PropTypes from "prop-types";

import { toast } from "../utils/toast";
const Register = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({ password: "" });

  const [form, setForm] = useState({
    username: "",
    email: "",
    password: "",
    role: "member",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await register(form);
      toast.error(res.data.message);
    } catch (error) {
      toast.error(error.response?.data?.error || "Registration failed");
    }
  };

  return (
    <div className="container">
      <div className="login-page">
        <div className="item">
          <div className="signin-wrap">
            <div className="elogo">
              <img src={emtlogo} alt="Logo" />
            </div>
            <div className="signin-form">
              <div className="title">
                <h3>Sign In</h3>
                <p>Sign in to your account to continue</p>
              </div>
              <div className="mi-gole">
                <p>
                  <a href="#">
                    <i className="mi"></i>Sign in with Microsoft
                  </a>
                </p>
                <p>
                  <a href="#">
                    <i className="go"></i>Sign in with Google
                  </a>
                </p>
              </div>
              <div className="line">
                <span>OR</span>
              </div>
              <div className="login-form">
                <form onSubmit={handleSubmit} className="loginwrap">
                  <div className="form-item">
                    <label>User Name</label>
                    <input
                      name="username"
                      placeholder="Username"
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="form-item">
                    <label>Email Address</label>
                    <input
                      name="email"
                      placeholder="Email"
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="form-item eye-icon">
                    <label>Password</label>
                    <input
                      name="password"
                      placeholder="Password"
                      type={showPassword ? "text" : "password"}
                      onChange={handleChange}
                      required
                    />
                    <div
                      className="pass-show"
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      <Icon name={showPassword ? "eye" : "eyeslash"} />
                    </div>
                  </div>
                  <div className="form-action">
                    <button type="submit" className="btn-orange">
                      Register
                    </button>
                  </div>
                  <p className="siup-txt">
                    Don't have an account? <a href="/login">Sign In</a>
                  </p>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div className="item">
          <img src={loginimg} alt="Logo" className="loginimg" />
        </div>
      </div>
    </div>
  );
};

export default Register;
